{
  "todayButton": "今日",
  "nextMonth": "来月",
  "previousMonth": "先月",
  "nextYear": "来年",
  "previousYear": "去年",
  "weekdays": [
    "日曜日",
    "月曜日",
    "火曜日",
    "水曜日",
    "木曜日",
    "金曜日",
    "土曜日"
  ],
  "months": [
    "一月",
    "二月",
    "三月",
    "四月",
    "五月",
    "六月",
    "七月",
    "八月",
    "九月",
    "十月",
    "十一月",
    "十二月"
  ]
}
